import React from 'react';
import DashboardShell from './DashboardShell';
import {useDashboardData} from './useDashboardData';
import {CategoryBarChart, TrendLineChart, DonutBreakdown} from '../../../components/charts';

type CommsData = {
    volume_by_channel: {name: string; value: number}[];
    activity_by_day: {date: string; count: number}[];
    calls_by_status: {name: string; value: number}[];
};

/** Communications Engagement (P2) - execution_strategy_activity_tracker.md
 * Phase 4.4. WhatsApp/SMS/Voice/WebMeeting all had real records, never
 * visualized together. */
const CommunicationsEngagementDashboard: React.FC = () => {
    const {data, loading, error} = useDashboardData<CommsData>('/admin-dashboard/dashboards/communications/');

    return (
        <DashboardShell
            title="Communications Engagement"
            subtitle="Message and call volume across every channel"
            loading={loading}
            error={error}
        >
            {data && (
                <div className="row g-3">
                    <div className="col-lg-5">
                        <div className="uz-panel h-100">
                            <div className="uz-panel-header"><span className="uz-section-title">Volume by Channel</span></div>
                            <div className="uz-panel-body">
                                <CategoryBarChart data={data.volume_by_channel} xKey="name" yKey="value" colorByCategory/>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4">
                        <div className="uz-panel h-100">
                            <div className="uz-panel-header"><span className="uz-section-title">Activity (14 days)</span></div>
                            <div className="uz-panel-body">
                                <TrendLineChart data={data.activity_by_day} xKey="date" yKey="count" height={200}/>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3">
                        <div className="uz-panel h-100">
                            <div className="uz-panel-header"><span className="uz-section-title">Calls by Status</span></div>
                            <div className="uz-panel-body">
                                <DonutBreakdown data={data.calls_by_status} height={200}/>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </DashboardShell>
    );
};

export default CommunicationsEngagementDashboard;
